var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_2",
    d: "M18.2519 18C16.9217 18 15.5853 17.6907 14.2427 17.0721C12.9002 16.4535 11.6668 15.5809 10.5423 14.4544C9.41794 13.3276 8.54647 12.0941 7.92788 10.7538C7.30929 9.41353 7 8.07829 7 6.74806C7 6.53429 7.07059 6.35618 7.21176 6.21371C7.35294 6.07124 7.52941 6 7.74118 6H10.0434C10.2216 6 10.3789 6.05818 10.5151 6.17453C10.6514 6.29076 10.738 6.43441 10.7751 6.60547L11.1797 8.68235C11.2077 8.87506 11.2018 9.04065 11.1621 9.17912C11.1222 9.31759 11.0506 9.43388 10.9475 9.528L9.31724 11.115C9.57959 11.5955 9.87935 12.05 10.2165 12.4786C10.5536 12.9071 10.9185 13.3163 11.3114 13.7063C11.6986 14.0937 12.1104 14.4535 12.5466 14.7856C12.9829 15.1177 13.4539 15.4268 13.9598 15.7128L15.5438 14.115C15.6543 14.0001 15.7881 13.9195 15.9451 13.8732C16.1021 13.8271 16.2652 13.8158 16.4345 13.8394L18.3945 14.2385C18.5728 14.2856 18.7182 14.3765 18.8309 14.5114C18.9436 14.6462 19 14.7991 19 14.9702V17.2588C19 17.4706 18.9288 17.6471 18.7863 17.7882C18.6438 17.9294 18.4657 18 18.2519 18ZM8.81624 10.1132L10.0761 8.90771C10.0986 8.88959 10.1134 8.86471 10.1202 8.83306C10.127 8.80141 10.1259 8.772 10.1168 8.74482L9.80994 7.16735C9.80088 7.13124 9.78506 7.10412 9.76247 7.086C9.73988 7.06788 9.71047 7.05882 9.67424 7.05882H8.16471C8.13753 7.05882 8.11488 7.06788 8.09676 7.086C8.07876 7.10412 8.06976 7.12677 8.06976 7.15394C8.10588 7.63629 8.18482 8.12629 8.30659 8.62394C8.42824 9.12171 8.59812 9.61812 8.81624 10.1132ZM14.9574 16.2136C15.4253 16.4317 15.9133 16.5985 16.4214 16.7139C16.9296 16.8292 17.4045 16.8977 17.8461 16.9195C17.8732 16.9195 17.8959 16.9104 17.914 16.8923C17.9321 16.8742 17.9412 16.8515 17.9412 16.8244V15.3394C17.9412 15.3031 17.9321 15.2737 17.914 15.2511C17.8959 15.2285 17.8688 15.2127 17.8326 15.2036L16.3503 14.9022C16.3231 14.8932 16.2994 14.8921 16.279 14.8989C16.2586 14.9057 16.2371 14.9204 16.2144 14.943L14.9574 16.2136Z",
    fill: "var(--primary-icon-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.3b8496db6bee96bb832b33da8b089e4b.svg";
export { ForwardRef as ReactComponent };